const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_airbnb-revenue-plus/artifacts/k3vyn6pv_1.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-24 md:pt-40 md:pb-32 lg:pb-40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-12 items-end">
        <div className="col-span-12 lg:col-span-7 reveal">
          <p className="overline mb-8" data-testid="hero-eyebrow">
            10 Years Branding · Now For Short-Stay Hospitality
          </p>
          <h1
            data-testid="hero-heading"
            className="font-serif-editorial text-[3.25rem] sm:text-6xl lg:text-[6.25rem] leading-[0.95] tracking-[-0.02em] text-[#1A1A1A] font-light"
          >
            A branded property
            <br />
            <span className="italic text-[#6B5C4D]">out-earns</span>
            <br />
            a listed one.
          </h1>
          <p className="mt-10 max-w-xl text-[#5C564D] text-lg leading-relaxed">
            Ten years designing brands across fashion, food and hospitality —
            now channelled into a single, quiet discipline: turning
            extraordinary short-stay properties into destinations that
            command a premium, hold their occupancy, and get booked direct.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-inquire"
              className="inline-flex items-center h-14 px-8 bg-[#1A1A1A] text-[#FAF9F6] text-[12px] tracking-[0.24em] uppercase font-medium hover:bg-[#A89680] transition-colors duration-500"
            >
              Begin an Inquiry
            </a>
            <a
              href="#work"
              data-testid="hero-cta-work"
              className="inline-flex items-center h-14 px-8 border border-[#1A1A1A]/25 text-[12px] tracking-[0.24em] uppercase text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#FAF9F6] transition-colors duration-500"
            >
              View Portfolio
            </a>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-5 reveal">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={HERO_IMG}
              alt="Modern luxury villa at dusk"
              className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out hover:scale-[1.05]"
              loading="eager"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-white/85 backdrop-blur-md p-5 border border-black/5">
              <p className="overline mb-2">Flagship Case Study · 01</p>
              <p className="font-serif-editorial text-2xl leading-tight text-[#1A1A1A]">
                Mirrored Palms
              </p>
              <p className="text-sm text-[#5C564D] mt-1">
                Paradise Valley, AZ · Launched May 18, 2026
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Trust marquee */}
      <div className="mt-24 md:mt-32 border-y border-black/10 py-6 overflow-hidden">
        <div className="marquee-track flex gap-16 whitespace-nowrap w-max text-[#1A1A1A]/70">
          {[
            "10 Years Branding",
            "Fashion",
            "Food & Beverage",
            "Hospitality",
            "Retail",
            "Wellness",
            "Advertising",
            "Now — Short-Stay",
          ]
            .concat([
              "10 Years Branding",
              "Fashion",
              "Food & Beverage",
              "Hospitality",
              "Retail",
              "Wellness",
              "Advertising",
              "Now — Short-Stay",
            ])
            .map((name, i) => (
              <span
                key={i}
                className="font-serif-editorial italic text-2xl md:text-3xl"
                data-testid={`hero-marquee-item-${i}`}
              >
                {name}
              </span>
            ))}
        </div>
      </div>
    </section>
  );
}
